/**
 *    @author:
 *    @since:
 *
 */

import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, Name, OrderOfBC, ParentInfo } from '../_common/data/input-data';
import { GAData, Path, Progress } from "../_common/constant/page-const";
import { BirthCertificateValidation } from './birth_certificate.validator';
import { ItemList } from '../_common/constant/item-list';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { TranslateService } from '@ngx-translate/core';
import { Confirm, Language } from 'src/refresh/service/constant';
import { CommonService } from 'src/refresh/service/common-service';
import { ProgressService } from 'src/refresh/service/progress-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';

@Component({
      selector: 'birth_certificate',
      templateUrl: './birth_certificate.component.html',
      styleUrls: ['./birth_certificate.component.less']
})
export class BirthCertificateComponent extends FormBaseComponent implements OnInit {

      orderOfBC: OrderOfBC;
      childNameParam: Object;
      applicantChkBox: string;
      error_whichParent: string;
      error_isBcOrCertBC: string;
      error_invalidOrgName: string;
      error_invalidConsent: string;
      error_invalidSubmit: string;
      lang: string;
      public certifyingCount: number;
      public isOtherCustody: boolean;

      @ViewChild('canvas', { static: true })
      canvas: ElementRef<HTMLCanvasElement>;

      @ViewChild('parentalCanvas', { static: true })
      parentalCanvas: ElementRef<HTMLCanvasElement>;

      @ViewChild('bcSimpleCanvas', { static: true })
      bcSimpleCanvas: ElementRef<HTMLCanvasElement>;

      @ViewChild('bcParentalLightBox', { static: true })
      box1: LightBox;

      @ViewChild('bcSimpleLightBox', { static: true })
      box2: LightBox;

      //private ctx: CanvasRenderingContext2D;
      //private ctxSimpleBC: CanvasRenderingContext2D;

      zoomin: boolean = false;
      isBcOrCertBC: string;

      //FAQComponent = FAQComponent;

      //@ViewChild('faqLightBox', { static: true })
      //faqLightBox: LightBox;

      constructor(protected router: Router,
            public timerService: TimerService,
            public items: ItemList,
            public data: InputData,
            protected progress: ProgressService,
            private device: DeviceDetectorService,
            public translateService: TranslateService,
            public commonService: CommonService,
            public viewportScroller: ViewportScroller) {

            super(router, timerService);
            
            super.setNextPage(Path.Transition2, Path.Transition1);

            super.setValidator(new BirthCertificateValidation(this, Progress.OrderBC));

            this.orderOfBC = this.data.orderOfBC;

            if ( this.orderOfBC.chk_BCConsent == 'X') {
                 this.orderOfBC.chk_BCConsent = '';
                 super.forward();
                 return;
            }
 
            ///if (this.progress.progressStatus[Progress.OrderBC] == 4)  this.progress.progressStatus[Progress.OrderBC] = 1;

            this.childNameParam = { childName: this.data.aboutChild.name.getFullName() };
            this.applicantChkBox = this.data.orderOfBC.applicantIndex > -1 ? "Y" : "N";

            this.certifyingCount = this.data.eligibility.certifyingParentCount;
            this.isOtherCustody = this.data.eligibility.isCustodyOtherThanParent == Confirm.YES;

            this.lang = this.translateService.currentLang;

            this.commonService.getCloseLightBox().subscribe((r) =>{
                  //if(this.isFaqLightBoxOpen) this.onFaqClose();
                  if(this.isBox1Open) this.onBox1Close();
                  if(this.isBox2Open) this.onBox2Close();
            });

            

            InputData.currentPageIdx = 18;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {
            
            if ( super.forwardNext(InputData.currentPageIdx) ) return;
            
            this.bcParentalDraw();
            this.bcSimpleDraw();

            this.commonService.setBCImageClose( () => {
                 if ( this.isBox1Open || this.isBox2Open )
                      this.closeBoxes();
            });
      }

      onNoBirthCertificateClick() {
            this.progress.progressStatus[Progress.OrderBC] = 4;
            this.router.navigate([Path.BirthCertificateAreYouSure]);
            super.gtag(GAData.Button, GAData.no_BC);
      }

      private bcParentalDraw() {
            let ctx: CanvasRenderingContext2D = this.parentalCanvas.nativeElement.getContext('2d');
            let img = document.getElementById("myCanvas_" + this.lang) as HTMLImageElement;

            let self = this;
            img.onload = function () {
                  ctx.fillStyle = "#000";

                  let w: number;
                  let h: number;
                  let rate: number = 1.262857;
                  if (self.device.isMobile()) {

                        w = window.innerWidth * 0.95;
                        h = w * rate;

                        self.parentalCanvas.nativeElement.width  = window.innerWidth;
                        self.parentalCanvas.nativeElement.height = window.innerWidth * rate;
                  }
                  else {
                        self.parentalCanvas.nativeElement.width = 525;
                        self.parentalCanvas.nativeElement.height = 663;
                  }

                  setTimeout(() => {
                        if (self.device.isMobile()) {
                              ctx.font = "bold  8pt Helvetica";
                              ctx.drawImage(img, 0, 0, w, h);
                              
                              let nameArray = self.getChildFormattedName(self.data.aboutChild.name);
                              if(nameArray.length == 1){
                                    ctx.fillText(nameArray[0].toUpperCase(), w * 0.143, h * 0.605);
                              }else{
                                    ctx.fillText(nameArray[0].toUpperCase(),  w*0.143,  h * 0.585);
                                    ctx.fillText(nameArray[1].toUpperCase(),  w*0.143,  h * 0.613);
                              }

                              ctx.fillText(self.getBirthDate('PBC'), w*0.24, h*.649);

                              ctx.fillText(self.data.aboutChild.gender.toUpperCase(), w*0.706, h*.636);

                              ctx.fillText(self.getBirthPlace(), w*0.24, h*.7);
                              

                              let MAX = 186;   // 132
                              let row = h*.906;

                              /**
                               if (self.data.parents.length == 4) {
                                     ctx.font = "bold 7pt Helvetica Narrow";
                               }
                               else ctx.font = "bold 8pt Helvetica Narrow";
                                */

                              let x1 = w*.048;
                              let x2 = w*.602;
                              let rgap = 12;
                              if ( self.data.parents.length <= 3 ) rgap = 15;
                              self.parentsDraw(ctx, MAX, row, "bold 8pt Helvetica Narrow", x1, x2, 8, 10, 9, rgap);
                        }
                        else {
                              ctx.font = "bold 10pt Helvetica";
                              ctx.drawImage(img, 0, 0);

                              let nameArray = self.getChildFormattedName(self.data.aboutChild.name);
                              if(nameArray.length == 1){
                                    ctx.fillText(nameArray[0].toUpperCase(), 90, 395);
                              }else{
                                    ctx.fillText(nameArray[0].toUpperCase(), 90, 385);
                                    ctx.fillText(nameArray[1].toUpperCase(), 90, 400);
                              }

                              ctx.fillText(self.data.aboutChild.gender.toUpperCase(), 317, 440);
                              ctx.fillText(self.getBirthDate('PBC'), 154, 435);
                              ctx.fillText(self.getBirthPlace(), 154, 465);

                              let MAX = 286;
                              let row = 596;

                              let totalRow = 0;
                              self.data.parents.forEach((parent) => {

                                    let name: Name = parent.name;
                                    let pname: string[] = self.getParentFormattedName(name);
                                    totalRow += pname.length;
                              });

                              let rgap = 18;
                              if ( totalRow > 4 ) rgap = 16  - (totalRow-4);
            
                              self.parentsDraw(ctx, MAX, row, "bold 8pt Helvetica Narrow", 27, 316, 10, 12, 15, rgap);
                        }

                  }, 1000);
            };
      }


      private parentsDraw(ctx: CanvasRenderingContext2D, MAX, row, font, x1, x2, y1, y2, y3, y4) {
            ctx.font = font;
            let parents = Object.assign([], this.data.parents);
            this.sortForBirthParent(parents);

            let y_coord: number = 0;

            parents.forEach((parent) => {

                        let name: Name = parent.name;

                        let pname: string[] = this.getParentFormattedName(name);

                        if(pname.length == 1 ) {
                             y_coord = row;
                            ctx.fillText(pname[0].toUpperCase(), x1, row);  // 15
                        }
                        else {  
                             y_coord = row;
                             ctx.fillText(pname[0].toUpperCase(), x1, row);  // 15
                             ctx.fillText(pname[1].toUpperCase(), x1, row = row + 10);  // 15
                        }

                        let width = ctx.measureText(pname[0]).width;

                        if (width <= MAX) {

                            ctx.fillText(this.formatParentBirthPlace(ctx
                                              , parent.placeOfBirth.birthPlace.toUpperCase())
                                              , x2, y_coord);  // 180
                                    
                        }
                        else {
                            ctx.fillText(this.formatParentBirthPlace(ctx
                                              , parent.placeOfBirth.birthPlace.toUpperCase())
                                              , x1 + 4 + width
                                              , y_coord);
                        }

                        row += y4;                                   // 12
            });
      }
      
      private formatParentBirthPlace(ctx: CanvasRenderingContext2D, birthPlace: string){
            let MAX = 210;
            
            if(this.device.isMobile()){
                  MAX = 210 * 0.65;
            }

            let textWidht = ctx.measureText(birthPlace).width;
            let index = 1;
            
            while(textWidht > MAX){
                  //34 is a value chosen that we know for sure that it will not fit the length. 
                  //Then work backwards for birthPlace and stop as soon as width condition is met. 
                  birthPlace = birthPlace.substring(0, 34 - index);
                  textWidht = ctx.measureText(birthPlace).width;
                  index++;
            };
         
            return birthPlace;
      }

      sortForBirthParent(parents: ParentInfo[]): void{
            parents.sort(function(p1, p2){
                  let v1 = p1.isGiveBirth.toLowerCase();
                  let v2 = p2.isGiveBirth.toLowerCase();
                  if (v1 < v2) {return 1;}
                  if (v1 > v2) {return -1;}
                  return 0;
            });
      }

      private bcSimpleDraw() {
            let ctx: CanvasRenderingContext2D = this.bcSimpleCanvas.nativeElement.getContext('2d');
            let img = document.getElementById("bcSimpleImg_" + this.lang) as HTMLImageElement;

            let self = this;
            img.onload = function (){
                  ctx.fillStyle = "#000";
                  let w: number;
                  let h: number;
                  let rate: number = 1.262857;

                  if (self.device.isMobile()) {

                        w = window.innerWidth * 0.94;
                        h = w * rate;
      
                        self.bcSimpleCanvas.nativeElement.width = window.innerWidth;
                        self.bcSimpleCanvas.nativeElement.height = window.innerWidth * rate;
                  }
                  else {
                        self.bcSimpleCanvas.nativeElement.width = 525;
                        self.bcSimpleCanvas.nativeElement.height = 663;
                  }
      
                  setTimeout(() => {
                        if (self.device.isMobile()) {
                              ctx.font = "bold  8pt Helvetica";
                              ctx.drawImage(img, 0, 0, w, h);
      
                              let nameArray = self.getChildFormattedName(self.data.aboutChild.name);
                              if(nameArray.length == 1){
                                    ctx.fillText(nameArray[0],  w * 0.143, h * 0.582);
                              }else{
                                    ctx.fillText(nameArray[0],  w * 0.143, h * 0.565);
                                    ctx.fillText(nameArray[1],  w * 0.143, h * 0.595);
                              }

                              ctx.fillText(self.getBirthDate('BC'), w * 0.243, h * 0.660);
                              ctx.fillText(self.data.aboutChild.gender.toUpperCase(), w * 0.670, h * 0.640);
                              ctx.fillText(self.getBirthPlace(), w * 0.243, h * 0.715);
                        }
                        else {
                              ctx.font = "bold 10pt Helvetica";
                              ctx.drawImage(img, 0, 0);
                              let nameArray = self.getChildFormattedName(self.data.aboutChild.name);
                              if(nameArray.length == 1){
                                    ctx.fillText(nameArray[0], 90, 390);
                              }else{
                                    ctx.fillText(nameArray[0], 90, 385);
                                    ctx.fillText(nameArray[1], 90, 405);
                              }
                             
                              ctx.fillText(self.data.aboutChild.gender.toUpperCase(), 317, 448);
                              ctx.fillText(self.getBirthDate('BC'), 154, 444);
                              ctx.fillText(self.getBirthPlace(), 154, 478);
                        }
                  }, 1000);
            };
      }
     
      isChildDeceased(): boolean {
            return this.data.aboutChild.isChildDeceased == Confirm.YES;
      }

      getLegalCustodianName() {
            if (this.data.eligibility.isOtherSingleName == Confirm.YES)
                  return this.data.eligibility.otherSingleName;
            else {
                  return this.data.eligibility.otherFirstName + ' ' + this.data.eligibility.otherLastName;
            }
      }

      getBirthPlace() {
            let unknown : string = this.translateService.instant('shared.unknown');
            if (this.data.aboutChild.cityName.toLowerCase() == unknown.toLowerCase()){
                  return '';
            }

            return this.data.aboutChild.cityName.toUpperCase();
      }

      onNextClick() : boolean {

             if ( this.certifyingCount == 1 && this.applicantChkBox == 'Y') {
                  this.orderOfBC.applicantIndex = this.data.certifyingParents.keys().next().value;
             }

             if (this.isChildDeceased()) {
                  this.orderOfBC.hasBirthCertificate = "";
                  this.orderOfBC.hasBCWithParentInfo = "";
                  this.orderOfBC.isReviewOtherTypeBC = "";
            } else if (this.orderOfBC.isReviewOtherTypeBC != Confirm.YES) {
                  this.orderOfBC.hasBirthCertificate = "";
                  this.orderOfBC.hasCertifiedCopyOfBR = "";
            }

            if ( this.orderOfBC.hasBirthCertificate  == Confirm.YES ) this.orderOfBC.amountForBC = 25;
            else                                                      this.orderOfBC.amountForBC = 0;
            if ( this.orderOfBC.hasBCWithParentInfo  == Confirm.YES ) this.orderOfBC.amountForBCWithParent = 25;
            else                                                      this.orderOfBC.amountForBCWithParent = 0;
            if ( this.orderOfBC.hasCertifiedCopyOfBR == Confirm.YES ) this.orderOfBC.amountForCertifiedCopy = 35;
            else                                                      this.orderOfBC.amountForCertifiedCopy = 0;

            this.orderOfBC.total = this.orderOfBC.amountForBCWithParent + this.orderOfBC.amountForBC + this.orderOfBC.amountForCertifiedCopy;

            if ( super.onNextClick() ) {
                  this.progress.progressStatus[Progress.OrderBC] = 2;
                  super.gtag(GAData.Button,GAData.continue_product);   
            }
            else  this.progress.progressStatus[Progress.OrderBC] = 1;    

            

            return true;
      }

      getParentFormattedName(name: Name): string[] {
            let nameArray = this.getChildFormattedName(name); //use the same logic
            return nameArray;
      }

      getChildFormattedName(name: Name) : string[]{
            let nameArr = [];
            let hasAccentChar = Util.hasAccentChar(name.getFullName());

            if (name.chk_singleName == Confirm.YES) {
                  let singleName = hasAccentChar ? this.convertToTitled(name.single) : name.single.toUpperCase();

                  if (name.single.length < 39) {
                        nameArr.push(singleName);
                  } else {
                        //break in two lines
                        nameArr.push(singleName.substring(0, 39));
                        nameArr.push(singleName.substring(39));
                  }
            } else {
                  if ((name.first + name.middle + name.last).length <= 39) {
                        nameArr.push(this.buildName(name));
                  } else {
                        let fName = hasAccentChar ? this.convertToTitled(name.first) : name.first.toUpperCase();
                        let mName = hasAccentChar ? this.convertToTitled(name.middle) : name.middle.toUpperCase();
                        let lName = hasAccentChar ? this.convertToTitled(name.last) : name.last.toUpperCase();

                        if (lName.length >= 39) {
                              
                              if (lName.length >= 44 )
                                   nameArr.push(lName.substring(0, 44));
                              else nameArr.push(lName);
                              
                              nameArr.push((fName + ' ' + mName).substring(0, 39));

                        } else if ((lName + fName + mName).length >= 39) {
                              if((lName + fName).length <= 39){
                                    nameArr.push(lName + ', ' + fName);
                                    if(!Util.isEmpty(mName)){
                                          nameArr.push(mName);
                                    }
                              }else {
                                    let fNameArray = fName.split(' ');
                                    let line1 = lName + ', ';
                                    fNameArray.forEach((fn, index) => {
                                          let tmpLine = line1 + fn;
                                         
                                          if(tmpLine.length > 39){
                                                nameArr.push(tmpLine);
                                                let t = fNameArray.slice(index + 1).toString().replace(',', ' ');
                                                nameArr.push((t + ' ' + mName).substring(0,39));
                                                return;
                                          }

                                          line1 = tmpLine + ' ';
                                    });
                              }
                        }
                  }
            }

            return nameArr;
      }

      buildName(name: Name): string {
            let hasAccentedChar = Util.hasAccentChar(name.getFullName());

            let fullName = hasAccentedChar ? this.convertToTitled(name.last) : name.last.toUpperCase();

            if (name.first) {
                  fullName = fullName + ", " + (hasAccentedChar ? this.convertToTitled(name.first) : name.first.toUpperCase());
            }

            if (name.middle) {
                  fullName = fullName + " " +  (hasAccentedChar ? this.convertToTitled(name.middle) : name.middle.toUpperCase());
            }

            return fullName;
      }

      convertToTitled(value: string){
            let valueArr : string[] = value.split(' '); //if a name is combination for multiple words.
            let convertedValue: string = '';

            for(let v of valueArr){
                  convertedValue = (convertedValue + ' ' + v.trim().charAt(0).toUpperCase() 
                        + v.substring(1).toLowerCase()).trim();      
            }

            return convertedValue;
      }

      getBirthDate(type: string) {
            let month = '';
            let birthDateArray = this.data.aboutChild.birthDay.split("-");
            
            if(type === 'PBC'){
                  month = this.translateService.instant('birth_certificate.date.' + Number.parseInt(birthDateArray[1]));
            }else if(type === 'BC'){
                  month = this.translateService.instant('shared.date.' + Number.parseInt(birthDateArray[1]));
            }else{
                  return '';
            }

            if (this.translateService.currentLang == Language.ENGLISH) {
                  return month.toUpperCase() + " " + birthDateArray[2] + ", " + birthDateArray[0];
            } else if (this.translateService.currentLang == Language.FRENCH) {
                  return birthDateArray[2] + " " + month + " " + birthDateArray[0];
            }
      }

      isAddedToOrder() {

            return this.orderOfBC.hasCertifiedCopyOfBR == 'Y' ||
                   this.orderOfBC.hasBirthCertificate == 'Y'  || 
                   this.orderOfBC.hasBCWithParentInfo == 'Y';
      }


      isAddedToOrderForDeceasedChild() {

            let isOrdered = this.orderOfBC.hasCertifiedCopyOfBR == 'Y';

            if (!isOrdered) {
                  this.orderOfBC.chk_BCConsent = "";
                  this.orderOfBC.applicantIndex = -1;
                  this.applicantChkBox = "";
            }
            return isOrdered;
      }

      onReviewOtherTypeBCChange(){
            let otherBCSelected = this.orderOfBC.isReviewOtherTypeBC;

            if(otherBCSelected == 'N'){
                  this.orderOfBC.hasCertifiedCopyOfBR = 'N';
                  this.orderOfBC.hasBirthCertificate = 'N';
            }
      }

      changeAddedToOrder() {
            if (!this.isAddedToOrder()) {

                  this.orderOfBC.chk_BCConsent = "";
                  this.orderOfBC.applicantIndex = -1;
                  this.applicantChkBox = "";
                  
                  if (this.data.eligibility.isCustodyOtherThanParent == 'Y') {
                        this.orderOfBC.organizationForOther = '';
                  }
            } 
            else {
                  this.error_whichParent = "";
                  this.error_invalidSubmit = '';
            }
      }

      addToOrderAmount(bcType: string) {

            this.changeAddedToOrder();
      }

      changeValue() {
            this.orderOfBC.applicantIndex = (this.applicantChkBox == 'Y') ? 0 : -1;

            if (this.applicantChkBox != 'Y') {
                  this.orderOfBC.chk_BCConsent = "";
                  this.error_invalidConsent = '';
            }
      }

      isFaqLightBoxOpen: boolean = false;

      /**onFaqClick(event: MouseEvent) {
            event.preventDefault();
            if (!this.isFaqLightBoxOpen) {
                  this.commonService.expandFaqSection('birthCertificate', 'whatIsBCFaq');
                  this.faqLightBox.open();
                  this.isFaqLightBoxOpen = true;
            }
      }*/

      onFaqClick(event){
            event.preventDefault();
            this.commonService.expandFaqSection('birthCertificate', 'whatIsBCFaq');
            this.commonService.openLightBox(); 
            this.isFaqLightBoxOpen = true;
      }

      onFaqClose() {
            this.isFaqLightBoxOpen = false;
            this.commonService.closeLightBox();
      }

      isBox1Open: boolean = false;
      onBox1Open() {
            this.isBox1Open = true;
            this.box1.open();
      }

      onBox1Close() {
            this.isBox1Open = false;
            this.box1.close();
      }

      isBox2Open: boolean = false;
      onBox2Open() {
            this.isBox2Open = true;
            this.box2.open();
      }

      onBox2Close() {
            this.isBox2Open = false;
            this.box2.close();
      }

      public closeBoxes() {
             if ( this.isBox1Open ) this.onBox1Close();
             if ( this.isBox2Open ) this.onBox2Close();
      }

      public keyPressBox1(event:any) {
            if ( event.keyCode == 13 ) {
                  if(!this.isBox1Open)
                  this.onBox1Open();
            }
      }

      public keyPressBox2(event:any) {
            if ( event.keyCode == 13 ) {
                  if(!this.isBox2Open)
                  this.onBox2Open();
            }
      }

      @HostListener('document:keydown.escape', ['$event'])
      public escape(){
            if(this.isFaqLightBoxOpen) {
                  this.onFaqClose();
            }
            if(this.isBox1Open) {
                  this.onBox1Close();
            }
            if(this.isBox2Open) {
                  this.onBox2Close();
            }
  }
}
